import {
  Close,
  EmailOutlined,
  PersonOutlined,
  TagOutlined,
} from "@mui/icons-material";
import { Box, Dialog, Grid, Typography } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";
import { CustomInput, CustomPasswordInput } from "../Common/CustomInput";
import { CustomBtn } from "../Common/CustomBtn";
import { useNavigate } from "react-router-dom";

const MembershipModal = ({ open, handleClose, Transition }) => {
  const navigate = useNavigate();
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(25,29,41,0.85)",
          backdropFilter: "blur(8px)",
        },
      }}
    >
      <Box sx={{ height: "100%", px: 6, pb: 12 }}>
        <Box
          sx={{
            height: "50px",
            width: "50px",
            borderRadius: "9px",
            backgroundColor: "rgba(255,255,255,0.09)",
            position: "absolute",
            top: "5%",
            right: "2.5%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.2)",
            },
          }}
          onClick={handleClose}
        >
          <Close sx={{ color: colors.secondary, fontSize: "30px" }} />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            mt: 3,
          }}
        >
          <img
            src={require("../../assets/icons/logo_md.png")}
            alt="logo"
            style={{
              height: "50px",
              width: "30%",
              objectFit: "contain",
            }}
          />

          <Typography
            sx={{
              color: "#fff",
              fontSize: "28px",
              fontFamily: "Mulish-Regular",
              mb: -2,
            }}
          >
            Your gateway to{" "}
            <Typography
              component={"span"}
              sx={{
                color: "#fff",
                fontSize: "28px",
                fontFamily: "Mulish-ExtraBold",
              }}
            >
              engaging{" "}
            </Typography>
          </Typography>
          <Typography
            sx={{
              color: "#fff",
              fontSize: "28px",
              fontFamily: "Mulish-Regular",
            }}
          >
            discussions and{" "}
            <Typography
              component={"span"}
              sx={{
                color: "#fff",
                fontSize: "28px",
                fontFamily: "Mulish-ExtraBold",
              }}
            >
              events.
            </Typography>
          </Typography>

          <Grid
            container
            spacing={2}
            mt={4}
            sx={{
              width: "100%",
            }}
          >
            <Grid item size={{ xs: 12, sm: 4 }}>
              <CustomInput
                label="first Name"
                placeholder="e.g., William"
                type="text"
                Icon={PersonOutlined}
                // onChange={(e) => handleChange(e, "firstName")}
                width="100%"
                mT={2}
                color="#fff"
                borderColor={colors.secondary}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 4 }}>
              <CustomInput
                label="Last Name"
                placeholder="e.g., Marshal"
                type="text"
                Icon={PersonOutlined}
                // onChange={(e) => handleChange(e, "firstName")}
                width="100%"
                mT={2}
                color="#fff"
                borderColor={colors.secondary}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 4 }}>
              <CustomInput
                label="Phone No"
                placeholder="e.g., 567 876 6789"
                type="text"
                Icon={PersonOutlined}
                // onChange={(e) => handleChange(e, "firstName")}
                width="100%"
                mT={2}
                color="#fff"
                borderColor={colors.secondary}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 4 }}>
              <CustomInput
                label="email address"
                placeholder="e.g., hello@imzul.com"
                type="text"
                Icon={EmailOutlined}
                // onChange={(e) => handleChange(e, "firstName")}
                width="100%"
                mT={2}
                color="#fff"
                borderColor={colors.secondary}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 4 }}>
              <CustomPasswordInput
                label="Password"
                placeholder="e.g., ********"
                type="text"
                // onChange={(e) => handleChange(e, "firstName")}
                width="100%"
                mT={2}
                color="#fff"
                borderColor={colors.secondary}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 4 }}>
              <CustomPasswordInput
                label="Confirm Password"
                placeholder="e.g., ********"
                type="text"
                // onChange={(e) => handleChange(e, "firstName")}
                width="100%"
                mT={2}
                color="#fff"
                borderColor={colors.secondary}
              />
            </Grid>
            <Grid item size={{ xs: 12 }}>
              <CustomInput
                label="interest tags"
                placeholder="e.g., Music, Tech, Travel, etc."
                type="text"
                Icon={TagOutlined}
                // onChange={(e) => handleChange(e, "firstName")}
                width="100%"
                mT={2}
                color="#fff"
                borderColor={colors.secondary}
              />
            </Grid>
            <Grid item size={{ xs: 12 }}>
              <CustomInput
                label="Short Bio"
                placeholder="e.g., Hello, I am..."
                type="text"
                noIcon
                // onChange={(e) => handleChange(e, "firstName")}
                width="100%"
                mT={2}
                color="#fff"
                borderColor={colors.secondary}
              />
            </Grid>
          </Grid>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 4,
            pb: 6,
          }}
        >
          <CustomBtn
            width={"20%"}
            text="Await Approval"
            icon
            fontSize={"16px"}
          />
          <Typography
            sx={{
              color: "#fff",
              fontFamily: "Mulish-Regular",
              fontSize: "12px",
            }}
          >
            Already have an membership account?{" "}
            <Typography
              component={"span"}
              sx={{
                color: colors.secondary,
                fontFamily: "Mulish-Bold",
                fontSize: "12px",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => navigate("/sign-in")}
            >
              Sign In
            </Typography>
          </Typography>
        </Box>
      </Box>
    </Dialog>
  );
};

export default MembershipModal;
